<div id="banner-lillian" class="swiper-background d-lg-flex align-items-center s-pt-48 s-pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-md-11 col-lg-6">
                <div class="portada-title portada-title-linea primary-900">
                    <p class="p-display-bold neutral-0 s-mb-16">
                        <span class="border-y-1 border-neutral-0 text-shadow-28">PROYECTO FINANCIADO</span>
                    </p>
                    <h1 class="h1-display s-mb-8 primary-50 text-shadow-28">The Great Lillian Hall | <br class="salto-linea"> 10% | 6 meses</h1>
                </div>
            </div>
            <div>
                <div class="d-none d-lg-block col-md-11 col-lg-8">
                    <p class="primary-50 p-display text-shadow-28 s-mb-4">
                    ¡No te pierdas la siguiente! Activa las comunicaciones de SEGO Creative desde tu perfil
                    </p>
                </div>
            </div>

            <div class="s-mt-16 s-mt-lg-24">
                @if (plataformaId === 'CREATIVE') {
                <app-btn-link [linkId]="'btn-lillian'" [linkStyle]="'secondary'" [linkUrl]="'/' + slug"
                    [linkTitle]="'Ver detalles'" [linkClass]="'me-3'"></app-btn-link>
                }
                @else {
                <app-btn-link [linkId]="'btn-lillian'" [linkStyle]="'secondary'" [linkType]="'href'"
                    [linkUrl]="domainUrl + '/' + slug" [linkTitle]="'Ver detalles'"
                    [linkClass]="'me-3'"></app-btn-link>
                }
            </div>
        </div>
    </div>
</div>